import { css } from 'styled-components';

export const croppedTextCSS = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
